/* this file added by Bearer Web Developer  */
import React, { useEffect, useState } from 'react';
import { TTransportStateResponse } from "../../../api/bearer-api";
import styles from './showSteps.module.scss';
import { useThemeMode } from '../../../states/contexts/theme';  // added by Bearer Web Developer
import Timer from './timer';
import Steps from './steps';

interface IShowSteps {
    searchResponse: TTransportStateResponse | null
}
const ShowSteps: React.FC<IShowSteps> = ({ searchResponse }) => {
    const realtime_code = searchResponse?.realtime_code;
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    const hasTimer = realtime_code === 3 || realtime_code === 7;
    let seconds = 0;
    if (realtime_code === 3) {
        const event_time = searchResponse?.event_time_accepted_rider_ontheway_to_origin_in_ms;
        const time_n = searchResponse?.time_n;
        if (event_time && time_n) {
            const difference = Date.now() - event_time;
            const remaining_time = time_n - difference;
            if (remaining_time > 0) {
                seconds = Math.floor(remaining_time / 1000); // convert miliseconds to seconds
            }
        }
    }
    const [cancellation, setCancellation] = useState<boolean>(seconds <= 0);
    useEffect(() => {
        if (seconds <= 0) {
           if(!cancellation) setCancellation(true);
        } else {
            if(cancellation) setCancellation(false);
        }
    }, [seconds]);

    return (
        <div className={styles.show_steps_part} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <div className={!hasTimer ? '' : cancellation ? styles.cancel : styles.time}>
                {
                    hasTimer &&
                    <Timer seconds={seconds} onFinish={() => setCancellation(true)} withMinute={true} cancellation={cancellation} />
                }
                <Steps searchResponse={searchResponse} />
            </div>
        </div>
    )
}
export default ShowSteps;